import React from "react";
import { connect } from "react-redux";
import { Notify } from "react-redux-notify";
import { hideUserOTPModal } from "../../store/actions/ModalAction";

import OTPModal from "../Modals/OTPModal";
import Footer from "./Footer/Footer";
import AuthHeader from "./Header/AuthHeader";

const RegisterLayout = (props) => {
  const handleCloseOTPModal = () => {
    props.dispatch(hideUserOTPModal());
  };

  return (
    <div
      className="d-flex w-100"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Notify position="TopRight" />
      <AuthHeader />
      <div className="landing-main-wrapper dj">
        {React.cloneElement(props.children)}
      </div>
      <Footer />
      <OTPModal
        handleClose={handleCloseOTPModal}
        show={props.modals.userOTPModal.show}
        data={props.modals.userOTPModal}
        payload={props.modals.userOTPModal}
      />
    </div>
  );
};

const mapStateToPros = (state) => ({
  modals: state.modals,
  profile: state.users.profile,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(RegisterLayout);
